<template>
  <ChartContainer class="d-flex flex-column" :params.sync="params">
    <v-tabs active-class="tab-active" hide-slider>
      <v-tab class="d-flex flex-column"> Biểu đồ tần suất </v-tab>
    </v-tabs>
    <v-responsive :aspect-ratio="16 / 9">
      <v-card-text class="full-width full-height">
        <ChartLoadingContainer :loading="loading">
          <ChartJSComponent
            :key="keyRender"
            class="full-width full-height"
            :datasets="datasets"
            :labels="labels"
            :options="options"
            :type="chartType"
          />
        </ChartLoadingContainer>
      </v-card-text>
    </v-responsive>
  </ChartContainer>
</template>

<script>
import ChartJSComponent from '@components/chart/ChartJSComponent.vue'
import ChartContainer from '../ChartContainer.vue'
import ChartLoadingContainer from '@components/chart/ChartLoadingContainer.vue'
import sdk from '@service/auth-sdk'
import { debounce, getChartColor } from '@utils'
export default {
  components: {
    ChartJSComponent,
    ChartLoadingContainer,
    ChartContainer,
  },
  props: {},
  data: (vm) => ({
    params: { type: '7days' },
    loading: false,
    keyRender: 0,
    chartType: 'bar',
    labels: [],
    datasets: [
      {
        label: 'Truy cập trang chủ',
        data: [],
        lineTension: 0,
        fill: false,
        borderColor: getChartColor(0),
        backgroundColor: getChartColor(0),
      },
      {
        label: 'Kiểm tra vùng bay',
        data: [],
        lineTension: 0,
        fill: false,
        borderColor: getChartColor(1),
        backgroundColor: getChartColor(1),
      },
      {
        label: 'Khác',
        data: [],
        lineTension: 0,
        fill: false,
        borderColor: getChartColor(2),
        backgroundColor: getChartColor(2),
      },
    ],
    options: {
      title: {
        display: false,
      },
      layout: {
        padding: {
          left: 10,
          right: 10,
        },
      },
      tooltips: {
        mode: 'nearest',
        callbacks: {
          title: function(tooltipItem) {
            let corporation = new Date(tooltipItem[0].xLabel)
            return `${corporation
              .getDate()
              .toString()
              .padStart(2, '0')}/${(corporation.getMonth() + 1)
              .toString()
              .padStart(2, '0')}/${corporation.getFullYear()}`
          },
          label: function(tooltipItem, data) {
            let corporation = data.datasets[tooltipItem.datasetIndex].label
            return `${corporation}: ${vm.$n(tooltipItem.value)}`
          },
        },
      },
      legend: {
        display: true,
        position: 'bottom',
        align: 'start',
        labels: {
          usePointStyle: true,
          boxWidth: 6,
        },
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            ticks: {
              callback: function(value, index, values) {
                if (index == 0)
                  return `${value.getDate()}/Th.${value.getMonth() + 1}`
                else if (value.getMonth() != values[index - 1].getMonth())
                  return `${value.getDate()}/Th.${value.getMonth() + 1}`
                return `${value.getDate()}`
              },
            },
          },
        ],
        yAxes: [
          {
            stacked: true,
            ticks: {
              beginAtZero: true,
              precision: 0,
            },
          },
        ],
      },
    },
  }),
  computed: {},
  watch: {
    params: {
      handler: debounce(function() {
        this.fetchData()
      }, 100),
      deep: true,
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    getGrowthPercent(data = {}) {
      if (data.total_current > 0 || data.total_before > 0) {
        return round(
          ((data.total_current - data.total_before) /
            (data.total_before || 1)) *
            100
        )
      }
      return 0
    },
    async fetchData() {
      this.loading = true
      const res = await sdk.request({
        url: '/dashboard/traffic',
        params: this.params,
      })
      this.labels = []
      this.datasets[0].data = []
      this.datasets[1].data = []
      this.datasets[2].data = []
      let data = res.data
      data.forEach((element, i) => {
        this.labels.push(new Date(element.date))
        this.datasets[0].data[i] = 0
        this.datasets[1].data[i] = 0
        this.datasets[2].data[i] = 0
        Object.keys(element.data).forEach((key) => {
          if (key === 'view-home') {
            this.datasets[0].data[i] = element.data[key]
          } else if (key === 'check-flight-zone') {
            this.datasets[1].data[i] = element.data[key]
          } else {
            this.datasets[2].data[i] += element.data[key]
          }
        })
      })
      this.loading = false
    },
  },
}
function round(num) {
  var m = Number((Math.abs(num) * 100).toPrecision(15))
  return (Math.round(m) / 100) * Math.sign(num)
}
</script>

<style scoped></style>
